module.exports = __webpack_public_path__ + "static/img/1e54250f-11cb-4257-baac-e01a94bcdd53.19443171.png";